"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryBuilderProvider = exports.useQueryBuilderContext = exports.QueryBuilderContext = void 0;
const react_1 = __importStar(require("react"));
const entity_ui_1 = require("@sierralabs/entity-ui");
const query_core_1 = require("@sierralabs/query-core");
const plugins_1 = require("./plugins");
exports.QueryBuilderContext = (0, react_1.createContext)(null);
const useQueryBuilderContext = (params) => {
    const context = (0, react_1.useContext)(exports.QueryBuilderContext);
    if (!context && !(params === null || params === void 0 ? void 0 : params.ignoreUndefined)) {
        throw new Error('useQueryBuilderContext must be used within the context of the QueryBuilderProvider component');
    }
    return context;
};
exports.useQueryBuilderContext = useQueryBuilderContext;
exports.QueryBuilderProvider = (0, react_1.forwardRef)((_a, ref) => {
    var { query, enableQueryRefresh = false, children, onQueryChange } = _a, props = __rest(_a, ["query", "enableQueryRefresh", "children", "onQueryChange"]);
    const existingQueryBuilderContext = (0, exports.useQueryBuilderContext)({
        ignoreUndefined: true
    });
    // handle editing query state
    const queryRef = (0, react_1.useRef)(query);
    const onQueryChangeRef = (0, react_1.useRef)(onQueryChange);
    onQueryChangeRef.current = onQueryChange;
    // default entities to empty array while avoiding re-render
    const { entities: ctxEntities } = (0, entity_ui_1.useEntityContext)();
    const entities = (0, react_1.useMemo)(() => ctxEntities || [], [ctxEntities]);
    const [plugins, setPlugins] = (0, react_1.useState)(props.plugins || plugins_1.defaultQueryBuilderPlugins);
    const pluginsRef = (0, react_1.useRef)(plugins);
    pluginsRef.current = plugins;
    const [queryManager, setQueryManager] = (0, react_1.useState)(new query_core_1.QueryManager(query || {}, entities, plugins));
    //
    (0, react_1.useEffect)(() => {
        if (enableQueryRefresh && query && query !== queryRef.current) {
            queryRef.current = query;
            setQueryManager(new query_core_1.QueryManager(query, entities, pluginsRef.current));
        }
    }, [enableQueryRefresh, query, entities]);
    const setQuery = (0, react_1.useCallback)((query) => {
        setQueryManager(new query_core_1.QueryManager(query, entities, pluginsRef.current));
    }, [entities]);
    // Check if mainAlias field reference change then restart trackChanges to
    // update state. This is important to update where clause selector.
    (0, react_1.useEffect)(() => {
        const handleFromChange = () => {
            setQueryManager(new query_core_1.QueryManager(queryManager.query, entities));
        };
        queryManager.subscribe('fromChange', handleFromChange);
        return () => {
            queryManager.unsubscribe('fromChange', handleFromChange);
        };
    }, [queryManager, entities]);
    // bubble up any changes (for backwards compatibility)
    (0, react_1.useEffect)(() => {
        var _a;
        if (queryManager.history.uncommitted.length > 0) {
            (_a = onQueryChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onQueryChangeRef, queryManager.query);
        }
    }, [queryManager.history.uncommitted.length, queryManager.query]);
    const context = existingQueryBuilderContext || {
        initialQuery: query,
        queryManager,
        plugins,
        setPlugins,
        setQuery
    };
    // check if existing query builder context exists and update props
    (0, react_1.useEffect)(() => {
        if (existingQueryBuilderContext && plugins.length > 0) {
            existingQueryBuilderContext.setPlugins(plugins);
        }
    }, [existingQueryBuilderContext, plugins]);
    // useEffect(() => {
    //   if (existingQueryBuilderContext && query) {
    //     existingQueryBuilderContext.setQuery(query);
    //   }
    // }, [existingQueryBuilderContext, query]);
    react_1.default.useImperativeHandle(ref, () => context);
    // Make sure only one instance of the QueryBuilderContext exists (allows for component nesting)
    return existingQueryBuilderContext ? (react_1.default.createElement(react_1.default.Fragment, null, children)) : (react_1.default.createElement(exports.QueryBuilderContext.Provider, { value: context }, children));
});
//# sourceMappingURL=QueryBuilderContext.js.map